module.exports = __webpack_public_path__ + "img/logistics.95dd54d1.png";